export default {"src":"https://marketing-edge-assets.lemonade.com/_next/static/media/weather.939e130c.svg","height":69,"width":69,"blurWidth":0,"blurHeight":0};